import { create } from "zustand";
import {
  PopupBodyType,
  PopupProperties,
  PopupPropertiesUpdaterFn,
  SetPopupBodyFn,
  SetPopupPropertiesFn,
  UpdatePopupPropertiesFn,
} from "./types";

interface State {
  popupBody: PopupBodyType;
  popupProperties: PopupProperties;
}

interface Action {
  setPopupBody: SetPopupBodyFn;
  setPopupProperties: SetPopupPropertiesFn;
  updatePopupProperties: UpdatePopupPropertiesFn;
}

const usePopupStore = create<State & Action>((set, get) => ({
  popupBody: null,
  popupProperties: {},
  setPopupBody: (popupBody: PopupBodyType): void => {
    if (popupBody === null) {
      get().setPopupProperties({});
    }
    set({ popupBody });
  },
  setPopupProperties: (popupProperties: PopupProperties): void => {
    set({ popupProperties });
  },
  updatePopupProperties: (updater: PopupPropertiesUpdaterFn): void => {
    set((state) => ({ popupProperties: updater(state.popupProperties) }));
  },
}));

export default usePopupStore;
